
define('template!webshopCategoryAddView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="code item">\n    <div class="libelle">' +
((__t = ( _.i18n('common.code') )) == null ? '' : __t) +
'</div>\n    <div class="code-region"></div>\n</div>\n<div class="category item">\n    <div class="libelle">' +
((__t = ( _.i18n('common.parent-category') )) == null ? '' : __t) +
'</div>\n    <div class="category-region"></div>\n</div>';

}
return __p
};});

